import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./styles.css";
import Counter from "./counter";
import { GuestsType } from "../../model/utils";
import { fieldChanged, focusOn } from "../../store/actions";
import useCloseOnBlur from "../use-close-on-blur";

const mapDispatchToProps = dispatch => ({
  fieldChanged: fieldName => dispatch(fieldChanged(fieldName)),
  focusOn: fieldName => dispatch(focusOn(fieldName))
});

const GuestsSelector = ({
  fieldName,
  fieldChanged,
  focusOn,
  focusedField,
  numGuests,
  setNumGuests,
  maxGuests,
  disabled
}) => {
  const [opened, setOpened] = React.useState(false);
  const [openedNumGuests, setOpenedNumGuests] = React.useState(numGuests);

  const onFocus = useCloseOnBlur(
    focusOn,
    fieldName,
    focusedField,
    opened,
    setOpened
  );

  const ng = opened ? openedNumGuests : numGuests;
  const sng = opened ? setOpenedNumGuests : setNumGuests;

  const onToggle = () => {
    if (disabled) {
      return;
    }
    onFocus();
    if (!opened) {
      setOpenedNumGuests(numGuests);
    }
    setOpened(!opened);
  };

  const onConfirm = () => {
    setNumGuests(openedNumGuests);
    setOpened(false);
    if (fieldName) {
      fieldChanged(fieldName);
    }
  };

  React.useEffect(() => {
    if (focusedField !== fieldName && opened) {
      setOpened(false);
    }
  }, [focusedField, opened, fieldName]);

  return (
    <div
      styleName="guests-selector-container"
      id={`input-field-name-${fieldName}`}
    >
      <div
        styleName={"fake-select" + (disabled ? " disabled" : "")}
        onClick={onToggle}
      >
        {numGuests[0] + numGuests[1]}
      </div>
      {!disabled && (
        <div styleName="caret">
          <i className={`fa fa-angle-${opened ? "up" : "down"}`}></i>
        </div>
      )}
      {opened && (
        <div styleName="popover">
          <div styleName="popover-row">
            <div styleName="label">Adulti</div>
            <div styleName="counter">
              <Counter
                value={ng[0]}
                setValue={newValue => sng([newValue, ng[1]])}
                minValue={1}
                maxValue={maxGuests - ng[1]}
              />
            </div>
          </div>
          <div styleName="divisor" />
          <div styleName="popover-row">
            <div styleName="label">Bambini</div>
            <div styleName="sublabel">Età fino a 12 anni</div>
            <div styleName="counter">
              <Counter
                value={ng[1]}
                setValue={newValue => sng([ng[0], newValue])}
                minValue={0}
                maxValue={maxGuests - ng[0]}
              />
            </div>
          </div>
          <button type="button" styleName="confirm-button" onClick={onConfirm}>
            Conferma
          </button>
        </div>
      )}
    </div>
  );
};

GuestsSelector.propTypes = {
  fieldName: PropTypes.string,
  fieldChanged: PropTypes.func.isRequired,
  focusOn: PropTypes.func.isRequired,
  numGuests: GuestsType.isRequired,
  setNumGuests: PropTypes.func.isRequired,
  maxGuests: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  focusedField: PropTypes.string
};

export default connect(
  ({ focusedField }, ownProps) => ({ ...ownProps, focusedField }),
  mapDispatchToProps
)(GuestsSelector);
